import React from "react";
import ReactEcharts from "echarts-for-react";

// Function to calculate the linear regression (y = mx + b)
const getLinearTrend = (data) => {
  const n = data.length;
  const x = Array.from({ length: n }, (_, i) => i + 1); // Index as x-axis values
  const y = data;

  // Calculate the sum of x, y, x^2, and xy
  const sumX = x.reduce((acc, val) => acc + val, 0);
  const sumY = y.reduce((acc, val) => acc + val, 0);
  const sumXY = x.reduce((acc, val, idx) => acc + val * y[idx], 0);
  const sumX2 = x.reduce((acc, val) => acc + val * val, 0);

  // Calculate the slope (m) and intercept (b)
  const m = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
  const b = (sumY - m * sumX) / n;

  // Calculate the trend line values (y = mx + b) for each x
  const trendLine = x.map((val) => m * val + b);
  return trendLine;
};

const CreditorsDay1 = () => {
  const dates = [
    "Nov-19", "Dec-19", "Jan-20", "Feb-20", "Mar-20", "Apr-20", "May-20", "Jun-20", "Jul-20", "Aug-20", "Sep-20", "Oct-20", 
    "Nov-20", "Dec-20", "Jan-21", "Feb-21", "Mar-21", "Apr-21", "May-21", "Jun-21", "Jul-21", "Aug-21", "Sep-21", "Oct-21", 
    "Nov-21", "Dec-21", "Jan-22", "Feb-22", "Mar-22", "Apr-22", "May-22", "Jun-22", "Jul-22", "Aug-22", "Sep-22", "Oct-22", 
    "Nov-22", "Dec-22", "Jan-23", "Feb-23", "Mar-23", "Apr-23", "May-23", "Jun-23", "Jul-23", "Aug-23", "Sep-23", "Oct-23", 
    "Nov-23", "Dec-23", "Jan-24", "Feb-24", "Mar-24", "Apr-24", "May-24", "Jun-24", "Jul-24", "Aug-24", "Sep-24", "Oct-24"
  ];

  const creditorsDaysOutstanding = [
    6.0, 1.1, 10.6, 7.6, 7.3, 13.8, 13.7, 4.9, 15.3, 6.4, 9.6, 7.2, 9.5, 9.5, 6.9, 25.7, 20.1, 18.0, 16.4, 14.0, 8.9, 
    12.9, 8.8, 8.1, 9.3, 2.3, 6.1, 11.6, 7.7, 8.9, 9.8, 5.6, 7.7, 7.8, 9.7, 7.3, 5.0, 5.0, 8.4, 8.9, 9.7, 9.7, 13.1, 
    10.9, 18.1, 13.9, 22.3, 16.5, 13.1, 10.5, 9.6, 7.2, 13.5, 15.1, 11.1, 9.0, 9.3, 6.3, 3.8, 6.6
  ];

  // Calculate the trend line for Creditors Days Outstanding
  const trendLine = getLinearTrend(creditorsDaysOutstanding);

  const option = {
    tooltip: { trigger: "axis" },
    legend: { data: ["Creditors Days Outstanding", "Trend Line"] },
    xAxis: {
      type: "category",
      data: dates,
      axisLabel: {
        rotate: 45, // Rotate labels to fit better
      }
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: "{value} days"
      }
    },
    series: [
      {
        name: "Creditors Days Outstanding",
        type: "line",
        data: creditorsDaysOutstanding,
        smooth: true,
        lineStyle: { color: "blue" },
        markPoint: {
          data: [{ type: "max", name: "Max Value" }, { type: "min", name: "Min Value" }],
        },
      },
      {
        name: "Trend Line",
        type: "line",
        data: trendLine,
        smooth: true,
        lineStyle: { type: "dashed", color: "red" },
      },
    ],
  };

  return <ReactEcharts option={option} style={{ height: "500px" }} />;
};

export default CreditorsDay1;
